import React from 'react';
import './panelists.scss';
import SwiperCarousel from './SwiperCarousel';

function Panelists() {
  // const containerRef = useRef();
  // useLayoutEffect(() => {
  //   const observer = new IntersectionObserver(
  //     function (entries) {
  //       entries.forEach((entry) => {
  //         if (entry.intersectionRatio > 0.1) {
  //           entry.target.style.animation = 'fade-in 0.5s linear forwards';
  //         }
  //       });
  //     },
  //     { threshold: [0, 0.1] }
  //   );

  //   observer.observe(containerRef.current);
  // }, []);
  return (
    <div className="panelists">
      <SwiperCarousel />
    </div>
  );
}

export default Panelists;
